import { memo } from "react";
import { Text, View, Page, Document, PDFViewer, } from '@react-pdf/renderer';
import styles from "../pdf/Styles.js";
import "../pdf/Fonts.js";

const OwnerPopulationPdf = ({
    selectedOwner,
    aliveAnimals,
    deadAnimals,
    selectedYear,
}) => {
    const Divider = () => {
        return (
            <View
                style={{
                    borderBottomWidth: 1,
                    borderBottomColor: 'black',
                    marginVertical: 10,
                }}
            />
        );
    };

    const renderAnimals = (animals) => {
        if (!animals || animals.length === 0) {
            return (
                <View style={styles.sisterCategory}>
                    <Text style={styles.subheading}>Δεδομένα Γαλακτοπαραγωγής:</Text>
                    <Text style={styles.sisterCell}>Δεν υπάρχουν διαθέσιμα δεδομένα γαλακτοπαραγωγής για τα ζώα αυτής της μονάδας</Text>
                </View>
            );
        }

        return (
            <View style={styles.sisterCategory}>
                <View style={styles.sisterTable}>
                    <View style={styles.sisterTableHeader}>
                        <Text style={styles.sisterCell}>A/A</Text>
                        <Text style={styles.sisterCell}>Γενεαλογικός Κωδικός</Text>
                        <Text style={styles.sisterCell}>Κωδικός στην Εκτροφή</Text>
                        <Text style={styles.sisterCell}>Ημερομηνία Γέννησης</Text>
                        <Text style={styles.sisterCell}>Φύλο</Text>
                        <Text style={styles.sisterCell}>Ημερομηνία Εγγραφής</Text>
                        <Text style={styles.sisterCell}>Φυλή</Text>
                        <Text style={styles.sisterCell}>Πατέρας</Text>
                        <Text style={styles.sisterCell}>Μητέρα</Text>
                    </View>
                    {animals.map((record, index) => {
                        return (
                            <View key={index} style={styles.sisterRow}>
                                <Text style={styles.sisterCell}>{index + 1}</Text>
                                <Text style={styles.sisterCell}>{record?.registrationCode}</Text>
                                <Text style={styles.sisterCell}>{record?.flockCode}</Text>
                                <Text style={styles.sisterCell}>{new Date(record?.birthDate).toLocaleDateString("el-GR")}</Text>
                                <Text style={styles.sisterCell}>{record?.sex}</Text>
                                <Text style={styles.sisterCell}>{record?.registrationDate ? new Date(record?.registrationDate).toLocaleDateString("el-GR") : ""}</Text>
                                <Text style={styles.sisterCell}>{record?.breedCode}</Text>
                                <Text style={styles.sisterCell}>{record?.sireCode === "Unknown" ? "" : record?.sireCode}</Text>
                                <Text style={styles.sisterCell}>{record?.damCode === "Unknown" ? "" : record?.damCode}</Text>
                            </View>
                        );
                    })}
                </View>
            </View>
        );
    };
    return (
        <>
            <PDFViewer style={{ width: "85vw", height: "100vh" }}>
                <Document>
                    <Page size="A3" style={styles.page} wrap>
                        <View style={styles.mainHeader}>
                            <Text >{`Δελτίο Απογραφής για το έτος ${selectedYear}`}</Text>
                        </View>
                        <Divider />
                        <View style={styles.mainSubHeader}>
                            <Text >{`Στοιχεία Μονάδας`}</Text>
                        </View>
                        <View style={{ flexDirection: 'row', justifyContent: 'center', marginVertical: 20 }}>
                            {/* Owner Name */}
                            <View style={{ marginHorizontal: 8, alignItems: 'center' }}>
                                <Text style={{ fontSize: 12 }}>{`Όνομα: ${selectedOwner?.lastName} ${selectedOwner?.firstName}`}</Text>
                            </View>

                            {/* Owner Address */}
                            <View style={{ marginHorizontal: 8, alignItems: 'center' }}>
                                <Text style={{ fontSize: 12 }}>{`Διεύθυνση: ${selectedOwner?.address}`}</Text>
                            </View>

                            {/* Owner Phone */}
                            <View style={{ marginHorizontal: 8, alignItems: 'center' }}>
                                <Text style={{ fontSize: 12 }}>{`Τηλέφωνο: ${selectedOwner?.phoneNumber}`}</Text>
                            </View>
                        </View>
                        <Divider />
                        <View style={styles.mainSubHeader}>
                            <Text >{`Παρόντα Ζώα`}</Text>
                        </View>
                        {renderAnimals(aliveAnimals)}
                        <Divider />
                        <View style={styles.mainSubHeader}>
                            <Text >{`Νεκρά Ζώα`}</Text>
                        </View>
                        {renderAnimals(deadAnimals)}
                    </Page>
                </Document>
            </PDFViewer>
        </>
    )
}

export default memo(OwnerPopulationPdf);